import { render, staticRenderFns } from "./_boxIcons.vue?vue&type=template&id=cab5a6c8&"
import script from "./_boxIcons.vue?vue&type=script&lang=js&"
export * from "./_boxIcons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports